import styled from "@emotion/styled";

export const PieWrap = styled.div`
    width: 100%;
    max-width: 520px;
    min-width: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        max-width: 100%;
        gap: 12px;

        padding-right: 18px;
        box-sizing: border-box;
    }
`;

export const PieLegend = styled.div`
  flex: 0 0 180px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex: 0 0 140px;
    gap: 8px;
  }
`;

export const PieLegendRow = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const PieLegendLabel = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.small};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PieLegendValue = styled.div`
  flex: 0 0 auto;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.small};
  opacity: 0.9;
`;

export const PieLegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex: 0 0 auto;
`;
